import { CellOccupancy } from "./CellOccupancy.js";

/**
 * Module-singleton occupancy index (E15).
 *
 * `CellOccupancy` was previously a private field on `CombatManager`,
 * which left the player-movement collision check (`canMoveTo`) and the
 * AI pathfinder unable to consult it without holding a manager
 * reference. Lifting it to a singleton lets `CombatManager`, the
 * spawn paths, and the collision detector all read/write the same
 * source of truth without threading the instance through every layer.
 *
 * The instance is mutable. Tests that need a clean slate call
 * `cellOccupancyStore.clear()` between cases.
 */
export const cellOccupancyStore = new CellOccupancy();

/** Convenience helper for tests. */
export function resetCellOccupancyStore(): void {
  cellOccupancyStore.clear();
}
